<template>
  <div class="home">
    <div id="nav">
      <b-button @click="sayHello()"><font-awesome-icon icon="calculator" aria-hidden="true" />
      {{ translate.calc }}
      <font-awesome-icon icon="arrow-circle-right" aria-hidden="true" />
      </b-button>
      </div>
  </div>
</template>

<script>
export default {
  computed: {
    translate() {
      const lang = this.$store.state.calc.currentLocale;
      return this[lang];
    },

  },
  data() {
    return {
      kz: { calc: 'Аквакультураның калькуляторы' },
      ru: { calc: 'Калькулятор аквакультуры' },
    };
  },
  methods: {
    sayHello() {
      this.$say('6.ogg');
      this.$router.push('regions');
    },
  },


  name: 'Home',
};
</script>


<style scoped>
#nav {
  padding-top:50px;
}

.btn-secondary {
    color: #fff;
    background-color: #00a745;
    border-color: #00a745;
}
</style>
